import getters from '@/store/modules/partner/getters'
import mutations from '@/store/modules/partner/mutations'
import actions from '@/store/modules/partner/actions'

export default {
  namespaced: true,
  state() {
    return {}
  },
  getters,
  actions,
  mutations
}
